export const scoutEndpoints = {
  startFromPrompt: '/scout/start-from-prompt',
  session: '/jobs/{id}/source/scout',
  start: '/jobs/{id}/source/scout/start',
  nextRound: '/jobs/{id}/source/scout/targeting/next-round',
  previewQuery: '/jobs/{id}/source/scout/targeting/preview-query',
  previewMarketSize:
    '/jobs/{id}/source/scout/targeting/preview-query/market-size',
  previewCandidates: '/jobs/{id}/source/scout/targeting/preview-candidates',
  confirm: '/jobs/{id}/source/scout/targeting/confirm',
  abandon: '/jobs/{id}/source/scout/targeting/abandon',
} as const;

export const scoutDefaults = {
  rankedPreviewCandidateCap: 100,
  defaultMaxCandidates: 15,
} as const;
